// extracted by mini-css-extract-plugin
module.exports = {"noChartData":"NoChartData_noChartData__1Kxa6"};